import { UnlimitedCardSummaryItem } from './styles'
import Text from 'components/shared/Text'

interface CardDetailRowProps {
    title: string
    children: React.ReactNode
    isLast?: boolean
}

const CardDetailRow = ({ title, children, isLast }: CardDetailRowProps) => (
    <UnlimitedCardSummaryItem
        direction="row"
        hasBorderBottom={!isLast}
        pb={!isLast ? 16 : 0}
        gap={24}
        isFullWidth
    >
        <Text variant="bodySmall" color="grayscale_700">
            {title}
        </Text>
        <Text variant="bodySmallStrong" color="grayscale_900">
            {children}
        </Text>
    </UnlimitedCardSummaryItem>
)

export default CardDetailRow
